import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import submit from "submit-form";
import { isPullActiveCoach } from "../../../../utils/user-helpers";

const PublishTeam = ({ locals, cycleId, cycleName }) => {
  const { t } = useTranslation("coaching-portal");
  const { pushAccountInfo, pressAccountInfo, pullAccountInfo, referAsClients } =
    locals?.activeUserToRequest || {};
  const isCommunityChatEnabled =
    pushAccountInfo?.inAppCommunityEnabled ||
    pressAccountInfo?.inAppCommunityEnabled ||
    pullAccountInfo?.inAppCommunityEnabled;

  const coachIsPullForRealsies = isPullActiveCoach(locals?.activeUserToRequest);
  const hideFromPush = locals?.editCycle?.hideFromPush;

  const isPullOnly =
    (coachIsPullForRealsies && !pushAccountInfo) ||
    (coachIsPullForRealsies && pushAccountInfo && hideFromPush);
  const isPullAndPush =
    coachIsPullForRealsies && pushAccountInfo && !hideFromPush;

  const memberLabel = referAsClients
    ? t("teams.publishTeam.clients")
    : t("teams.publishTeam.athletes");

  const [enableChat, setEnableChat] = useState(isCommunityChatEnabled);

  const mainParagraph = isPullOnly ? (
    <p>{t("teams.publishTeam.introPullOnly", { memberLabel })}</p>
  ) : isPullAndPush ? (
    <p>{t("teams.publishTeam.introPullAndPush", { memberLabel })}</p>
  ) : (
    <p>{t("teams.publishTeam.intro")}</p>
  );

  const showChatUi = true;

  return (
    <Modal
      className={"publish-team-modal"}
      header={false}
      toClear={["cycleId", "cycleName"]}
    >
      <div className={"body"}>
        <h3 className="text-center">{t("teams.publishTeam.title")}</h3>
        {mainParagraph}
        {pushAccountInfo && hideFromPush && (
          <p className="enable-chat">
            {t("teams.publishTeam.hiddenFromPushNote")}
          </p>
        )}
        <div className="divisor"></div>
        <p className="s1 mt-3 mb-3 text-center">
          <strong>{t("teams.publishTeam.whatToKnow")}</strong>
        </p>
        <ul>
          <li>
            <p>{t("teams.publishTeam.ongoingPrograms")}</p>
          </li>
          <li>
            <p>
              {t("teams.publishTeam.autoRelease")}{" "}
              {isPullOnly
                ? (referAsClients ? t("teams.publishTeam.clients") : t("teams.publishTeam.athletes"))
                : isPullAndPush
                  ? t("teams.publishTeam.subscribersAndMembers", { memberLabel: referAsClients ? t("teams.publishTeam.clients") : t("teams.publishTeam.athletes") })
                  : t("teams.publishTeam.subscribers")}
              .
            </p>
          </li>
          <li>
            <p>{t("teams.publishTeam.addEditWeeks")}</p>
          </li>
          {showChatUi && !!isCommunityChatEnabled && (
            <li>
              <p>
                {t("teams.publishTeam.privateChannel")}
                {isPullAndPush && (
                  <> {t("teams.publishTeam.chatPushOnly")}</>
                )}
              </p>
            </li>
          )}
        </ul>

        {showChatUi && !isCommunityChatEnabled && (
          <div className="enable-chat">
            <p>{t("teams.publishTeam.enableChatIntro")}</p>
            {isPullAndPush && (
              <p className="enable-chat">
                {t("teams.publishTeam.chatPushOnlyNote")}
              </p>
            )}

            <div className="enable-chat-input">
              <input
                type="checkbox"
                id="enableChat"
                name="enableChat"
                checked={enableChat}
                onChange={() => setEnableChat((state) => !state)}
              />
              <label htmlFor="enableChat">
                {t("teams.publishTeam.enableChatOptional")}
              </label>
            </div>
          </div>
        )}
      </div>

      <footer id="confirmation-modal-footer">
        <button
          type="button"
          data-button-type="secondary"
          onClick={() => {
            submit(`/actions/refresh?`, {
              method: "GET",
              body: {
                "modal[type]": "",
                cycleId: "",
                cycleName: "",
              },
            });
          }}
        >
          <span>{t("teams.publishTeam.cancel")}</span>
        </button>
        <button
          type="button"
          data-button-type={"primary"}
          onClick={() => {
            submit(`/actions/cycle/teams-publish/${cycleId}?`, {
              method: "POST",
              body: {
                subject: cycleName,
                guests: [],
                enableChat: enableChat,
              },
            });
          }}
        >
          {t("teams.publishTeam.publish")}
        </button>
      </footer>
    </Modal>
  );
};

export default PublishTeam;
